var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraserActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4473 33.2752H24.85L37.7619 19.8635L37.7626 19.8627C38.3962 19.2005 38.7496 18.3107 38.7496 17.3856C38.7496 16.4605 38.3962 15.5706 37.7626 14.9085L37.7611 14.9069L27.0811 3.88264L27.0715 3.87276L27.0612 3.86366L26.8982 3.71992C26.8979 3.71964 26.8976 3.71937 26.8973 3.7191C26.2405 3.13214 25.3903 2.82111 24.5173 2.85122C23.6438 2.88134 22.8158 3.25052 22.1991 3.88152L22.1976 3.88304L2.23877 24.5505L2.2374 24.552C1.60328 25.2161 1.24961 26.1079 1.24961 27.0349C1.24961 27.9618 1.60328 28.8536 2.23739 29.5178L2.23878 29.5192L9.50402 37.0424L9.60722 37.1492H9.75579H33.4473H33.7973V36.7992V33.6252V33.2752H33.4473ZM10.7614 21.2074L24.6333 6.877L34.821 17.4277L20.9771 31.7292L10.7614 21.2074ZM11.1997 33.2752L5.17849 27.0345L8.10265 23.9948L17.123 33.2752H11.1997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserActive);
export default __webpack_public_path__ + "static/media/eraser_active.2934f89de214b863259f5c0718035547.svg";
export { ForwardRef as ReactComponent };